import { StatusNotice } from "../../../ui/StatusNotice";
import { NoActivePlaySectionProps } from "./NoActivePlaySection.contract";

export function NoActivePlaySection({
  notice,
  onStartNewPlay,
  onImportZip,
  onLoadMockBag,
}: NoActivePlaySectionProps) {
  return (
    <section
      className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16"
      aria-labelledby="hero-title"
    >
      <div className="flex flex-col gap-6">
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-accent">
          No active play
        </p>
        <h1
          id="hero-title"
          className="text-4xl md:text-5xl font-extrabold text-brand-ink leading-[1.15]"
        >
          Ready to chase the monyawn?
        </h1>
        <p className="text-lg text-brand-muted leading-relaxed max-w-2xl">
          You haven&apos;t picked a play yet. Start fresh, restore a ZIP, or load the mock bag to
          explore.
        </p>
        <div className="flex flex-wrap gap-4 mt-8">
          <button
            className="bg-brand-accent text-white px-6 py-2.5 rounded-xl font-bold hover:bg-brand-accent-strong transition-all shadow-sm active:scale-95"
            type="button"
            onClick={onStartNewPlay}
          >
            Start a new play
          </button>
          <div className="flex flex-wrap items-center gap-2 rounded-xl border border-black/10 bg-white/60 px-2 py-2">
            <label className="bg-brand-surface border border-black/10 text-brand-ink px-4 py-2 rounded-xl text-sm font-medium hover:bg-black/5 transition-all active:scale-95 cursor-pointer inline-flex items-center">
              Restore a ZIP
              <input type="file" accept=".zip" className="hidden" onChange={onImportZip} />
            </label>
            <button
              className="text-brand-muted px-3 py-2 text-sm font-semibold hover:text-brand-ink transition-colors"
              type="button"
              onClick={onLoadMockBag}
            >
              Load mock bag
            </button>
          </div>
        </div>
        {notice && <StatusNotice tone={notice.tone} message={notice.message} className="mt-8" />}
      </div>
    </section>
  );
}
